import { useRouter } from "next/navigation";
import { useCallback, useMemo } from "react";

interface OriginLinkRewriter {
  match: (url: string) => boolean;
  rewrite: () => string | null;
}

const useCiamSsoRedirect = () => {
  const router = useRouter();

  const standaloneRewriter: OriginLinkRewriter = useMemo(
    () => ({
      match: (url: string) => url.includes("/ao-membership/"),
      rewrite: () => "standaloneFiveStar",
    }),
    [],
  );

  //redirect link is correct for journey, but use origin of fivestar as we want the CIM journey to be correct and consistent (account creation CTA text etc) as no mvno origin set up on that side yet
  const mobileSimRewriter: OriginLinkRewriter = useMemo(
    () => ({
      match: (url: string) => url.includes("/mobile-sim/"),
      rewrite: () => "standaloneFiveStar",
    }),
    [],
  );

  const addSimRewriter: OriginLinkRewriter = useMemo(
    () => ({
      match: (url: string) => url.includes("/add-sim/"),
      rewrite: () => null,
    }),
    [],
  );

  const defaultRewriter: OriginLinkRewriter = useMemo(
    () => ({
      match: (url: string) => url.length > 0,
      rewrite: () => null,
    }),
    [],
  );

  const urlRewriters: OriginLinkRewriter[] = useMemo(
    () => [
      standaloneRewriter,
      mobileSimRewriter,
      addSimRewriter,
      defaultRewriter,
    ], // DEFAULT MUST ALWAYS BE LAST!
    [standaloneRewriter, mobileSimRewriter, addSimRewriter, defaultRewriter],
  );

  const originLinkFactory = useCallback(() => {
    const currentUrl = window.location.href;

    const rewriter = urlRewriters.find((rewriter) =>
      rewriter.match(currentUrl),
    );

    return rewriter?.rewrite() ?? currentUrl;
  }, [urlRewriters]);

  const ssoRedirect = useCallback(() => {
    window.ciamSDK
      .getSsoRedirectLink({
        origin: originLinkFactory(),
        redirectLink: window.location.href,
      })
      .then((url) => {
        router.push(url);
      })
      .catch((error) => {
        console.error(error);
      });
  }, [router, originLinkFactory]);

  return {
    ssoRedirect,
  };
};

export default useCiamSsoRedirect;
